module.exports = __webpack_public_path__ + "7edc5f3a0fe17931bca55c9f215f4ba9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-80.png
// module id = 147
// module chunks = 0